//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import City from 'src/store/models/City';
import QChip from 'quasar/src/components/chip/QChip.js';;
export default {
  name: 'CitySelect',
  components: {
    QChip: QChip
  },
  props: ['value', 'outlined', 'square', 'multiple'],
  data: function data() {
    return {
      query: ''
    };
  },
  computed: {
    cities: function cities() {
      var _this = this;
      return City.query().where('name', function (value) {
        return value !== null;
      }).where('name', function (value) {
        return _this.query.length ? value.toLowerCase().indexOf(_this.query.toLowerCase()) !== -1 : true;
      }).get();
    }
  },
  methods: {
    updateCity: function updateCity(val) {
      this.$emit('input', val);
      this.$refs.select.updateInputValue('');
      this.$refs.select.blur();
    },
    filterCities: function filterCities(val, update, abort) {
      var _this2 = this;
      City.api().get('/api/cities', {
        dataKey: 'data',
        params: {
          name: val
        }
      }).then(function (result) {
        update(function () {
          _this2.query = val;
        });
      }).catch(function () {
        abort();
      });
    }
  }
};